// 订单状态
export const status = [
  { name: '待支付', value: 0 },
  { name: '已支付', value: 1 },
  { name: '已接诊', value: 2 },
  { name: '已结束', value: 3 },
  { name: '已退款', value: 4 },
  { name: '已超时', value: 5 },
  { name: '取消', value: 6 },
];

// 处方订单状态
export const orderStatus = [
  { name: '待审核', value: 0 },
  { name: '待付款', value: 1 },
  { name: '已付款', value: 2 },
  { name: '已发货', value: 3 },
  { name: '已结束', value: 4 },
  { name: '审核失败', value: 5 },
  { name: '已退款', value: 6 },
  { name: '已过期', value: 7 },
  { name: '未预约', value: 8 },
];

export const satisfactionStatus = [
  { name: '很满意', value: 5 },
  { name: '满意', value: 4 },
  { name: '基本满意', value: 3 },
  { name: '一般', value: 2 },
  { name: '不满意', value: 1 },
  { name: '非常不满意', value: '' },
];

export const drugType = [
  { name: '颗粒剂', value: 1 },
  { name: '西药', value: 2 },
  { name: '中成药', value: 3 },
  { name: '饮片', value: 4 },
];

// 商城订单状态
export const SHOP_ORDER_STATUS = [
  { value: 1, name: '待付款' },
  { value: 2, name: '已付款' },
  { value: 3, name: '已发货' },
  { value: 4, name: '已结束' },
  { value: 5, name: '已退款' },
  { value: 6, name: '已过期' },
  { value: 7, name: '己取消' },
];
